import { useBrand } from '../context/BrandContext';
import FastestFormRegister from './fastestform/Register';
import AbleRegister from './able/Register';

export default function Register() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleRegister /> : <FastestFormRegister />;
}
